module.exports = __webpack_public_path__ + "img/fs_lola-medium-webfont.b6a423f3.svg";